const DEBUG = false;
const CI = false;

export { CI, DEBUG };
